import { useSelector } from "react-redux";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import {
  CoreFlightsComponent,
  type PlatformComponentProps,
  Funnel,
} from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { PageLoadingScreen } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./FlightListLoading.module.scss";
import { AccountSelectors } from "@/modules/account";
import { useGetCurrentFunnel } from "@/utilities/hooks/useGetCurrentFunnel";

export interface FlightListLoadingComponentProps
  extends PlatformComponentProps {
  isLoading?: boolean;
}
export const FlightListLoading = ({
  isLoading,
  className,
  children,
}: FlightListLoadingComponentProps) => {
  const styles = useFlightStyles(
    CoreFlightsComponent.FlightListLoading,
    defaultStyles
  );
  const [block] = useModuleBEM(styles, CoreFlightsComponent.FlightListLoading);

  const { t } = useI18nContext();

  const isFixedPointsPricingEligible = useSelector(
    AccountSelectors.getIsFixedPointsPricingEligible
  );

  const currentFunnel = useGetCurrentFunnel();
  const isInPackagesFlow = currentFunnel === Funnel.Package;

  return (
    <PageLoadingScreen
      isLoading={isLoading}
      className={clsx(block, className)}
      text={
        isFixedPointsPricingEligible && !isInPackagesFlow
          ? t("flightSearchLoaderCard.title")
          : t("flightSearchLoadingText")
      }
      subtitle={
        isFixedPointsPricingEligible && !isInPackagesFlow
          ? t("flightSearchLoaderCard.subtitle")
          : t("flightSearchLoadingSubtitle")
      }
    >
      {children}
    </PageLoadingScreen>
  );
};
